import { useState } from "react";
import { TestItem } from "../types";
import { useTestPaymentStore } from "../hooks/use-test-payment-store";
import { RemoveTestConfirmationModal } from "./remove-test-confirmation-modal";

interface TestListProps {
  tests: TestItem[];
}

export function TestList({ tests }: TestListProps) {
  const { removeItem } = useTestPaymentStore();
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [testToRemove, setTestToRemove] = useState<TestItem | null>(null);

  const handleRemoveClick = (test: TestItem) => {
    setTestToRemove(test);
    setIsConfirmationOpen(true);
  };

  const handleConfirmRemove = () => {
    if (testToRemove) {
      removeItem(testToRemove._id);
    }
    setIsConfirmationOpen(false);
    setTestToRemove(null);
  };

  const handleCancelRemove = () => {
    setIsConfirmationOpen(false);
    setTestToRemove(null);
  };

  if (tests.length === 0) {
    return (
      <div className="py-4 text-center text-gray-500">
        No tests in this order
      </div>
    );
  }

  return (
    <>
      <div className="space-y-6">
        {tests.map((test) => (
          <div key={test._id} className="flex items-start">
            <div className="h-3 w-3 mt-1.5 rounded-full bg-emerald-500 flex-shrink-0" />
            <div className="ml-3 flex-grow">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-2">
                <div className="flex-1">
                  <h3 className="font-medium text-gray-900">
                    {test.testName}
                  </h3>
                </div>
                <div className="flex justify-between sm:flex-col sm:items-end items-center mt-3 sm:mt-0">
                  <span className="text-primary font-medium">
                    ₦{(test.markedUpTestPrice || 0).toLocaleString('en-NG', { maximumFractionDigits: 2 })}
                  </span>
                  <button
                    onClick={() => handleRemoveClick(test)}
                    className="text-sm text-red-500 hover:text-red-700 sm:mt-1"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <RemoveTestConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleCancelRemove}
        onConfirm={handleConfirmRemove}
        test={testToRemove}
      />
    </>
  );
}
